var _defs, _text, _text2, _text3, _text4, _text5, _g, _g2, _g3, _g4, _path, _path2, _text6, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLargescooterstand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1451,
    height: 1454,
    viewBox: "0 0 1451 1454",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#a1a0a0;font-size:22px;font-family:DMSans-Regular,DM Sans}.cls-10,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7{fill:none}.cls-2,.cls-3{stroke:#a1a0a0;stroke-width:2px}.cls-2{stroke-linecap:round;stroke-linejoin:round}.cls-4,.cls-5{stroke:#000}.cls-4{stroke-width:3px}.cls-6,.cls-8{stroke:#707070}.cls-8{fill:#fff}.cls-11,.cls-9{stroke:none}.cls-11{fill:#707070}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Large_scooter_stand",
    "data-name": "Large scooter stand",
    transform: "translate(-46 -2045.5)"
  }, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_48.80",
    "data-name": 48.8,
    className: "cls-1",
    transform: "translate(58.377 2373)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "48.80"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "_36.00_",
    "data-name": 36,
    className: "cls-1",
    transform: "translate(131 2469.333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "36.00 "))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "_43.00",
    "data-name": 43,
    className: "cls-1",
    transform: "translate(46 3229)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "43.00"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    id: "_74.00",
    "data-name": 74,
    className: "cls-1",
    transform: "translate(655 2773.333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "74.00"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    id: "_25.00",
    "data-name": 25,
    className: "cls-1",
    transform: "translate(138 3093)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "25.00"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TULU_ride_-_4_scooters_TOP",
    "data-name": "TULU ride - 4 scooters TOP",
    transform: "translate(-780 -1013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1021",
    "data-name": "Group 1021",
    transform: "rotate(-90 2683.135 1826.134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_233",
    "data-name": "Line 233",
    className: "cls-2",
    transform: "translate(0 7.227)",
    d: "M247.768 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231",
    "data-name": "Line 231",
    className: "cls-3",
    d: "M11.498 0 0 7.226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_232",
    "data-name": "Line 232",
    className: "cls-3",
    transform: "translate(0 7.227)",
    d: "M11.498 7.226 0 0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1041",
    "data-name": "Group 1041",
    transform: "rotate(90 -1544.524 2415.977)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791-2",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_233-2",
    "data-name": "Line 233",
    className: "cls-2",
    transform: "translate(0 7.227)",
    d: "M247.768 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231-2",
    "data-name": "Line 231",
    className: "cls-3",
    d: "M11.498 0 0 7.226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_232-2",
    "data-name": "Line 232",
    className: "cls-3",
    transform: "translate(0 7.227)",
    d: "M11.498 7.226 0 0"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Line_416",
    "data-name": "Line 416",
    className: "cls-2",
    transform: "translate(911.5 4237.5)",
    d: "M127.376 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_401",
    "data-name": "Line 401",
    className: "cls-2",
    transform: "translate(838.377 3958.5)",
    d: "M164.123 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_402",
    "data-name": "Line 402",
    className: "cls-2",
    transform: "translate(838.377 4511.5)",
    d: "M256.123 0H0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1951",
    "data-name": "Rectangle 1951",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h38v245.571H0z",
    transform: "translate(1010.615 3957.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1.5 1.5h35v242.571h-35z",
    transform: "translate(1010.615 3957.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1952",
    "data-name": "Rectangle 1952",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h38v245.571H0z",
    transform: "translate(1874.615 3958)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1.5 1.5h35v242.571h-35z",
    transform: "translate(1874.615 3958)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line_389",
    "data-name": "Line 389",
    className: "cls-4",
    transform: "translate(1047.115 3959)",
    d: "M0 0h830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_390",
    "data-name": "Line 390",
    className: "cls-5",
    transform: "translate(1047.115 4019)",
    d: "M0 0h830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_391",
    "data-name": "Line 391",
    className: "cls-5",
    transform: "translate(1047.115 4105)",
    d: "M0 0h830"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1010",
    "data-name": "Group 1010",
    transform: "translate(796.615 2007.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4246",
    "data-name": "Path 4246",
    className: "cls-6",
    d: "M10353.239-3337.292h42.135l14.044-90.926v-281.575h-70.224v281.575z",
    transform: "translate(-9375.694 5807.292)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_852",
    "data-name": "Group 852",
    transform: "translate(897 2029.232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_242",
    "data-name": "Line 242",
    className: "cls-6",
    transform: "translate(.577 6.138)",
    d: "M5.26 0 0 15.779"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_798",
    "data-name": "Group 798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4248",
    "data-name": "Path 4248",
    className: "cls-6",
    d: "M10259.815-3798.321s89.378-14.045 191.523 0",
    transform: "translate(-10253.432 3805.331)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4249",
    "data-name": "Path 4249",
    className: "cls-6",
    d: "M10256.172-3791.045s140.45-6.384 203.014 0",
    transform: "translate(-10256.172 3813.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_241",
    "data-name": "Line 241",
    className: "cls-6",
    transform: "translate(198.692 6.138)",
    d: "m0 0 3.506 15.779"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union_51",
    "data-name": "Union 51",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 49.116V13h.078C.87 5.7 7.6 0 15.782 0s14.907 5.7 15.7 13h.076v36.116z",
    transform: "translate(85.607 19.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M30.556 48.116V13.762l-.07-.652c-.357-3.287-2.034-6.334-4.724-8.578C23.032 2.254 19.487 1 15.782 1 12.075 1 8.53 2.254 5.798 4.532c-2.69 2.244-4.369 5.29-4.726 8.579L1 13.773v34.343h29.556m1 1H0V13.003h.078C.87 5.703 7.598 0 15.782 0c8.182 0 14.907 5.704 15.698 13.003h.076v36.113z",
    transform: "translate(85.607 19.494)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2008",
    "data-name": "Rectangle 2008",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h37v12H0z",
    transform: "translate(980 2470)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h36v11H.5z",
    transform: "translate(980 2470)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2009",
    "data-name": "Rectangle 2009",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h22v23H0z",
    transform: "translate(988 2481)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h21v22H.5z",
    transform: "translate(988 2481)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2010",
    "data-name": "Rectangle 2010",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h22v25H0z",
    transform: "translate(988 1987)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h21v24H.5z",
    transform: "translate(988 1987)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1011",
    "data-name": "Group 1011",
    transform: "translate(574.615 2007.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4246-2",
    "data-name": "Path 4246",
    className: "cls-6",
    d: "M10353.239-3337.292h42.135l14.044-90.926v-281.575h-70.224v281.575z",
    transform: "translate(-9375.694 5807.292)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_852-2",
    "data-name": "Group 852",
    transform: "translate(897 2029.232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_242-2",
    "data-name": "Line 242",
    className: "cls-6",
    transform: "translate(.577 6.138)",
    d: "M5.26 0 0 15.779"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_798-2",
    "data-name": "Group 798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4248-2",
    "data-name": "Path 4248",
    className: "cls-6",
    d: "M10259.815-3798.321s89.378-14.045 191.523 0",
    transform: "translate(-10253.432 3805.331)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4249-2",
    "data-name": "Path 4249",
    className: "cls-6",
    d: "M10256.172-3791.045s140.45-6.384 203.014 0",
    transform: "translate(-10256.172 3813.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_241-2",
    "data-name": "Line 241",
    className: "cls-6",
    transform: "translate(198.692 6.138)",
    d: "m0 0 3.506 15.779"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union_51-2",
    "data-name": "Union 51",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 49.116V13h.078C.87 5.7 7.6 0 15.782 0s14.907 5.7 15.7 13h.076v36.116z",
    transform: "translate(85.607 19.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M30.556 48.116V13.762l-.07-.652c-.357-3.287-2.034-6.334-4.724-8.578C23.032 2.254 19.487 1 15.782 1 12.075 1 8.53 2.254 5.798 4.532c-2.69 2.244-4.369 5.29-4.726 8.579L1 13.773v34.343h29.556m1 1H0V13.003h.078C.87 5.703 7.598 0 15.782 0c8.182 0 14.907 5.704 15.698 13.003h.076v36.113z",
    transform: "translate(85.607 19.494)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2008-2",
    "data-name": "Rectangle 2008",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h37v12H0z",
    transform: "translate(980 2470)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h36v11H.5z",
    transform: "translate(980 2470)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2009-2",
    "data-name": "Rectangle 2009",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h22v23H0z",
    transform: "translate(988 2481)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h21v22H.5z",
    transform: "translate(988 2481)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2010-2",
    "data-name": "Rectangle 2010",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h22v25H0z",
    transform: "translate(988 1987)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h21v24H.5z",
    transform: "translate(988 1987)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1012",
    "data-name": "Group 1012",
    transform: "translate(352.615 2007.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4246-3",
    "data-name": "Path 4246",
    className: "cls-6",
    d: "M10353.239-3337.292h42.135l14.044-90.926v-281.575h-70.224v281.575z",
    transform: "translate(-9375.694 5807.292)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_852-3",
    "data-name": "Group 852",
    transform: "translate(897 2029.232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_242-3",
    "data-name": "Line 242",
    className: "cls-6",
    transform: "translate(.577 6.138)",
    d: "M5.26 0 0 15.779"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_798-3",
    "data-name": "Group 798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4248-3",
    "data-name": "Path 4248",
    className: "cls-6",
    d: "M10259.815-3798.321s89.378-14.045 191.523 0",
    transform: "translate(-10253.432 3805.331)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4249-3",
    "data-name": "Path 4249",
    className: "cls-6",
    d: "M10256.172-3791.045s140.45-6.384 203.014 0",
    transform: "translate(-10256.172 3813.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_241-3",
    "data-name": "Line 241",
    className: "cls-6",
    transform: "translate(198.692 6.138)",
    d: "m0 0 3.506 15.779"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union_51-3",
    "data-name": "Union 51",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 49.116V13h.078C.87 5.7 7.6 0 15.782 0s14.907 5.7 15.7 13h.076v36.116z",
    transform: "translate(85.607 19.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M30.556 48.116V13.762l-.07-.652c-.357-3.287-2.034-6.334-4.724-8.578C23.032 2.254 19.487 1 15.782 1 12.075 1 8.53 2.254 5.798 4.532c-2.69 2.244-4.369 5.29-4.726 8.579L1 13.773v34.343h29.556m1 1H0V13.003h.078C.87 5.703 7.598 0 15.782 0c8.182 0 14.907 5.704 15.698 13.003h.076v36.113z",
    transform: "translate(85.607 19.494)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2008-3",
    "data-name": "Rectangle 2008",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h37v12H0z",
    transform: "translate(980 2470)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h36v11H.5z",
    transform: "translate(980 2470)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2009-3",
    "data-name": "Rectangle 2009",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h22v23H0z",
    transform: "translate(988 2481)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h21v22H.5z",
    transform: "translate(988 2481)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2010-3",
    "data-name": "Rectangle 2010",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h22v25H0z",
    transform: "translate(988 1987)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h21v24H.5z",
    transform: "translate(988 1987)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1013",
    "data-name": "Group 1013",
    transform: "translate(130.615 2008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4246-4",
    "data-name": "Path 4246",
    className: "cls-6",
    d: "M10353.239-3337.292h42.135l14.044-90.926v-281.575h-70.224v281.575z",
    transform: "translate(-9375.694 5807.292)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_852-4",
    "data-name": "Group 852",
    transform: "translate(897 2029.232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_242-4",
    "data-name": "Line 242",
    className: "cls-6",
    transform: "translate(.577 6.138)",
    d: "M5.26 0 0 15.779"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_798-4",
    "data-name": "Group 798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4248-4",
    "data-name": "Path 4248",
    className: "cls-6",
    d: "M10259.815-3798.321s89.378-14.045 191.523 0",
    transform: "translate(-10253.432 3805.331)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4249-4",
    "data-name": "Path 4249",
    className: "cls-6",
    d: "M10256.172-3791.045s140.45-6.384 203.014 0",
    transform: "translate(-10256.172 3813.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_241-4",
    "data-name": "Line 241",
    className: "cls-6",
    transform: "translate(198.692 6.138)",
    d: "m0 0 3.506 15.779"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union_51-4",
    "data-name": "Union 51",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 49.116V13h.078C.87 5.7 7.6 0 15.782 0s14.907 5.7 15.7 13h.076v36.116z",
    transform: "translate(85.607 19.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M30.556 48.116V13.762l-.07-.652c-.357-3.287-2.034-6.334-4.724-8.578C23.032 2.254 19.487 1 15.782 1 12.075 1 8.53 2.254 5.798 4.532c-2.69 2.244-4.369 5.29-4.726 8.579L1 13.773v34.343h29.556m1 1H0V13.003h.078C.87 5.703 7.598 0 15.782 0c8.182 0 14.907 5.704 15.698 13.003h.076v36.113z",
    transform: "translate(85.607 19.494)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2008-4",
    "data-name": "Rectangle 2008",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h37v12H0z",
    transform: "translate(980 2470)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h36v11H.5z",
    transform: "translate(980 2470)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2009-4",
    "data-name": "Rectangle 2009",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h22v23H0z",
    transform: "translate(988 2481)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h21v22H.5z",
    transform: "translate(988 2481)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2010-4",
    "data-name": "Rectangle 2010",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h22v25H0z",
    transform: "translate(988 1987)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h21v24H.5z",
    transform: "translate(988 1987)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Line_394",
    "data-name": "Line 394",
    className: "cls-4",
    transform: "translate(1609.115 4237.738)",
    d: "M0 0h150.986"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_395",
    "data-name": "Line 395",
    className: "cls-4",
    transform: "translate(1387.115 4237.738)",
    d: "M0 0h150.986"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_396",
    "data-name": "Line 396",
    className: "cls-4",
    transform: "translate(1164.115 4237.571)",
    d: "M0 0h150.986"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4469",
    "data-name": "Path 4469",
    className: "cls-4",
    d: "M2800.5 493.25v37h47.25",
    transform: "translate(-1753.385 3707.25)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1014",
    "data-name": "Group 1014",
    transform: "rotate(-90 3034.17 1203.568)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4470",
    "data-name": "Path 4470",
    className: "cls-4",
    d: "M0 0v45.514h41.292"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "TULU_ride_-_4_scooters_FRONT",
    "data-name": "TULU ride - 4 scooters FRONT",
    transform: "translate(-780 -1013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1016",
    "data-name": "Group 1016",
    transform: "rotate(-90 2275.581 1418.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791-3",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_233-3",
    "data-name": "Line 233",
    className: "cls-2",
    transform: "translate(0 7.227)",
    d: "M284.162 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231-3",
    "data-name": "Line 231",
    className: "cls-3",
    d: "M11.498 0 0 7.226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_232-3",
    "data-name": "Line 232",
    className: "cls-3",
    transform: "translate(0 7.227)",
    d: "M11.498 7.226 0 0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1017",
    "data-name": "Group 1017",
    transform: "rotate(90 -1096.052 1967.948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791-4",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_233-4",
    "data-name": "Line 233",
    className: "cls-2",
    transform: "translate(0 7.227)",
    d: "M284.162 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231-4",
    "data-name": "Line 231",
    className: "cls-3",
    d: "M11.498 0 0 7.226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_232-4",
    "data-name": "Line 232",
    className: "cls-3",
    transform: "translate(0 7.227)",
    d: "M11.498 7.226 0 0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1019",
    "data-name": "Group 1019",
    transform: "rotate(180 953 1892.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791-5",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_233-5",
    "data-name": "Line 233",
    className: "cls-2",
    transform: "translate(.001 7.227)",
    d: "M386.499 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231-5",
    "data-name": "Line 231",
    className: "cls-3",
    d: "M11.498 0 0 7.226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_232-5",
    "data-name": "Line 232",
    className: "cls-3",
    transform: "translate(0 7.227)",
    d: "M11.498 7.226 0 0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1020",
    "data-name": "Group 1020",
    transform: "translate(1017 3771.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791-6",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_233-6",
    "data-name": "Line 233",
    className: "cls-2",
    transform: "translate(.001 7.227)",
    d: "M386.499 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231-6",
    "data-name": "Line 231",
    className: "cls-3",
    d: "M11.498 0 0 7.226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_232-6",
    "data-name": "Line 232",
    className: "cls-3",
    transform: "translate(0 7.227)",
    d: "M11.498 7.226 0 0"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Line_397",
    "data-name": "Line 397",
    className: "cls-2",
    transform: "translate(838.377 3059.5)",
    d: "M164.5 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_412",
    "data-name": "Line 412",
    className: "cls-2",
    transform: "translate(893.21 3247.5)",
    d: "M109.667 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_398",
    "data-name": "Line 398",
    className: "cls-2",
    transform: "translate(838.377 3700.5)",
    d: "M164.5 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_399",
    "data-name": "Line 399",
    className: "cls-2",
    transform: "translate(1010.5 3709.667)",
    d: "M0 0v93.166"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_400",
    "data-name": "Line 400",
    className: "cls-2",
    transform: "translate(1912.5 3709.667)",
    d: "M0 0v93.166"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1937",
    "data-name": "Rectangle 1937",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h38v452H0z",
    transform: "translate(1011 3248)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1.5 1.5h35v449h-35z",
    transform: "translate(1011 3248)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1939",
    "data-name": "Rectangle 1939",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h24v119H0z",
    transform: "translate(1024.615 3131.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1.5 1.5h21v116h-21z",
    transform: "translate(1024.615 3131.833)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1940",
    "data-name": "Rectangle 1940",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h24v119H0z",
    transform: "translate(1874.615 3131.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1.5 1.5h21v116h-21z",
    transform: "translate(1874.615 3131.833)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1938",
    "data-name": "Rectangle 1938",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h38v452H0z",
    transform: "translate(1874.615 3248.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1.5 1.5h35v449h-35z",
    transform: "translate(1874.615 3248.833)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1941",
    "data-name": "Rectangle 1941",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M26 0h822a26 26 0 0 1 26 26v49H0V26A26 26 0 0 1 26 0z",
    transform: "translate(1024.615 3060)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M26 1.5h822A24.5 24.5 0 0 1 872.5 26v46a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 72V26A24.5 24.5 0 0 1 26 1.5z",
    transform: "translate(1024.615 3060)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1942",
    "data-name": "Rectangle 1942",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h830v48H0z",
    transform: "translate(1047 3651.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1.5 1.5h827v45H1.5z",
    transform: "translate(1047 3651.833)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1943",
    "data-name": "Rectangle 1943",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M8 0h18a8 8 0 0 1 8 8v34H0V8a8 8 0 0 1 8-8z",
    transform: "translate(1112.615 3657.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M8 .5h18A7.5 7.5 0 0 1 33.5 8v33a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5V8A7.5 7.5 0 0 1 8 .5z",
    transform: "translate(1112.615 3657.833)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1947",
    "data-name": "Rectangle 1947",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h42v37H0z",
    transform: "translate(1108.615 3242.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h41v36H.5z",
    transform: "translate(1108.615 3242.833)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1948",
    "data-name": "Rectangle 1948",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h42v37H0z",
    transform: "translate(1330.615 3242.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h41v36H.5z",
    transform: "translate(1330.615 3242.833)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1949",
    "data-name": "Rectangle 1949",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h42v37H0z",
    transform: "translate(1552.615 3242.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h41v36H.5z",
    transform: "translate(1552.615 3242.833)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1950",
    "data-name": "Rectangle 1950",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0 0h42v37H0z",
    transform: "translate(1774.615 3242.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M.5.5h41v36H.5z",
    transform: "translate(1774.615 3242.833)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1944",
    "data-name": "Rectangle 1944",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M8 0h18a8 8 0 0 1 8 8v34H0V8a8 8 0 0 1 8-8z",
    transform: "translate(1334.615 3657.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M8 .5h18A7.5 7.5 0 0 1 33.5 8v33a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5V8A7.5 7.5 0 0 1 8 .5z",
    transform: "translate(1334.615 3657.833)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1945",
    "data-name": "Rectangle 1945",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M8 0h18a8 8 0 0 1 8 8v34H0V8a8 8 0 0 1 8-8z",
    transform: "translate(1556.615 3657.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M8 .5h18A7.5 7.5 0 0 1 33.5 8v33a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5V8A7.5 7.5 0 0 1 8 .5z",
    transform: "translate(1556.615 3657.833)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1946",
    "data-name": "Rectangle 1946",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M8 0h18a8 8 0 0 1 8 8v34H0V8a8 8 0 0 1 8-8z",
    transform: "translate(1778.615 3657.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M8 .5h18A7.5 7.5 0 0 1 33.5 8v33a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5V8A7.5 7.5 0 0 1 8 .5z",
    transform: "translate(1778.615 3657.833)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line_350",
    "data-name": "Line 350",
    className: "cls-5",
    transform: "translate(1049.115 3688.333)",
    d: "M0 0h64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_382",
    "data-name": "Line 382",
    className: "cls-5",
    transform: "translate(1813.115 3688.333)",
    d: "M0 0h64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_379",
    "data-name": "Line 379",
    className: "cls-5",
    transform: "translate(1146.615 3688.333)",
    d: "M0 0h188.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_380",
    "data-name": "Line 380",
    className: "cls-5",
    transform: "translate(1368.115 3688.333)",
    d: "M0 0h188.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_381",
    "data-name": "Line 381",
    className: "cls-5",
    transform: "translate(1591.115 3688.333)",
    d: "M0 0h188.5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1008",
    "data-name": "Group 1008",
    transform: "translate(796.615 1815.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_374",
    "data-name": "Line 374",
    className: "cls-5",
    transform: "translate(252 1433)",
    d: "M0 0h60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_375",
    "data-name": "Line 375",
    className: "cls-5",
    transform: "translate(252 1458)",
    d: "M0 0h60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1007",
    "data-name": "Group 1007",
    transform: "translate(796.615 1815.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_383",
    "data-name": "Line 383",
    className: "cls-5",
    transform: "translate(354 1433)",
    d: "M0 0h180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_384",
    "data-name": "Line 384",
    className: "cls-5",
    transform: "translate(354 1458)",
    d: "M0 0h180"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1006",
    "data-name": "Group 1006",
    transform: "translate(796.615 1815.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_385",
    "data-name": "Line 385",
    className: "cls-5",
    transform: "translate(576 1433)",
    d: "M0 0h180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_386",
    "data-name": "Line 386",
    className: "cls-5",
    transform: "translate(576 1458)",
    d: "M0 0h180"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1005",
    "data-name": "Group 1005",
    transform: "translate(795.615 1815.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_387",
    "data-name": "Line 387",
    className: "cls-5",
    transform: "translate(799 1433)",
    d: "M0 0h180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_388",
    "data-name": "Line 388",
    className: "cls-5",
    transform: "translate(799 1458)",
    d: "M0 0h180"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1004",
    "data-name": "Group 1004",
    transform: "translate(796.615 1815.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_377",
    "data-name": "Line 377",
    className: "cls-5",
    transform: "translate(1020 1433)",
    d: "M0 0h60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_378",
    "data-name": "Line 378",
    className: "cls-5",
    transform: "translate(1020 1458)",
    d: "M0 0h60"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4444",
    "data-name": "Path 4444",
    className: "cls-5",
    d: "m9259.938-3330.348 1.547 3.336h11.066l1.709-3.336z",
    transform: "translate(-7504.176 6604.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4445",
    "data-name": "Path 4445",
    className: "cls-5",
    d: "m9259.938-3330.348 1.547 3.336h11.066l1.709-3.336z",
    transform: "translate(-7726.176 6604.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4446",
    "data-name": "Path 4446",
    className: "cls-5",
    d: "m9259.938-3330.348 1.547 3.336h11.066l1.709-3.336z",
    transform: "translate(-7947.824 6604.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4447",
    "data-name": "Path 4447",
    className: "cls-5",
    d: "m9259.938-3330.348 1.547 3.336h11.066l1.709-3.336z",
    transform: "translate(-8169.824 6604.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4448",
    "data-name": "Path 4448",
    className: "cls-5",
    d: "m0 0 2.188 6.336h15.656L20.262 0z",
    transform: "rotate(180 569.688 1569.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4449",
    "data-name": "Path 4449",
    className: "cls-5",
    d: "m0 0 2.188 6.336h15.656L20.262 0z",
    transform: "rotate(180 680.688 1569.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4450",
    "data-name": "Path 4450",
    className: "cls-5",
    d: "m0 0 2.188 6.336h15.656L20.262 0z",
    transform: "rotate(180 791.688 1569.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4451",
    "data-name": "Path 4451",
    className: "cls-5",
    d: "m0 0 2.188 6.336h15.656L20.262 0z",
    transform: "rotate(180 902.688 1569.584)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "side_view_03",
    "data-name": "side view 03",
    transform: "translate(-780 -1013)"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1039",
    "data-name": "Group 1039",
    transform: "translate(2003 3771.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791-7",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_233-7",
    "data-name": "Line 233",
    className: "cls-2",
    transform: "translate(.001 7.227)",
    d: "M90.499 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231-7",
    "data-name": "Line 231",
    className: "cls-3",
    d: "M11.498 0 0 7.226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_232-7",
    "data-name": "Line 232",
    className: "cls-3",
    transform: "translate(0 7.227)",
    d: "M11.498 7.226 0 0"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1040",
    "data-name": "Group 1040",
    transform: "rotate(180 1135.684 1892.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791-8",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_233-8",
    "data-name": "Line 233",
    className: "cls-2",
    transform: "translate(.001 7.227)",
    d: "M95.868 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231-8",
    "data-name": "Line 231",
    className: "cls-3",
    d: "M11.498 0 0 7.226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_232-8",
    "data-name": "Line 232",
    className: "cls-3",
    transform: "translate(0 7.227)",
    d: "M11.498 7.226 0 0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line_413",
    "data-name": "Line 413",
    className: "cls-2",
    transform: "translate(1996.5 3709.667)",
    d: "M0 0v93.166"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Line_415",
    "data-name": "Line 415",
    className: "cls-2",
    transform: "translate(2276.5 3709.667)",
    d: "M0 0v93.166"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    id: "_25.00-2",
    "data-name": 25,
    className: "cls-1",
    transform: "translate(2104.31 3786.333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "25.00"))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Line_159",
    "data-name": "Line 159",
    className: "cls-4",
    transform: "translate(2131.31 3251.077)",
    d: "M126.768 0H0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Line_161",
    "data-name": "Line 161",
    className: "cls-4",
    transform: "translate(1996.5 3700.833)",
    d: "M126.768 0H0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Line_160",
    "data-name": "Line 160",
    className: "cls-4",
    transform: "translate(1996.5 3248.833)",
    d: "M0 451.848 136.81 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Line_162",
    "data-name": "Line 162",
    className: "cls-4",
    transform: "translate(2123.269 3248.833)",
    d: "M0 451.848 136.81 0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4088",
    "data-name": "Path 4088",
    className: "cls-4",
    d: "M6577-3273.865h146.6c10.092 0 6.025-8.033 0-9.708s-138.274-17.194-138.274-17.194z",
    transform: "translate(-4453.5 6974.6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Union_52",
    "data-name": "Union 52",
    className: "cls-7"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m67.061 232.308 12.048-42.022L0 3.925 9.243 0l80.793 190.329-.559.237-12.763 44.512z",
    transform: "translate(2044.033 3059.815)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m74.657 231.367 11.909-41.535L7.654 3.934l-3.72 1.58 78.352 184.578-11.514 40.16 3.885 1.115m2.057 3.711-9.653-2.77 12.048-42.021L0 3.925 9.243 0l80.793 190.329-.56.237-12.762 44.512z",
    style: {
      fill: "#000",
      stroke: "none"
    },
    transform: "translate(2044.033 3059.815)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargescooterstand);
export default __webpack_public_path__ + "static/media/large scooter stand.778b27968c63a7c4da5a7f1c1daee0ba.svg";
export { ForwardRef as ReactComponent };